// frontend/src/components/ErrorBoundary.jsx
import { Component } from "react";

export default class ErrorBoundary extends Component {
  state = { hasError: false, error: null };
  static getDerivedStateFromError(error) { return { hasError: true, error }; }
  componentDidCatch(error, info) { console.error("UI Error:", error, info); }
  render() {
    if (this.state.hasError) {
      return (
        <div className="p-6 text-center">
          <h1 className="text-xl font-semibold">Oups, quelque chose s’est mal passé.</h1>
          <p className="mt-2 text-sm opacity-70">Rechargez la page ou réessayez plus tard.</p>
        </div>
      );
    }
    return this.props.children;
  }
}
